import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { ActivatedRoute, } from '@angular/router';
import { enumMapper, LogLevel, } from '@models';
import { ODataFilterBuilder, } from '@pages/generics/filter-builder';
import { GridPageState, ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { buildODataQuery, FileDownloadService, JobService, LogService, MachineService, ModalService, ProcessService, RobotService, SessionsService, } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { combineLatest, of, } from 'rxjs';
import { filter, map, switchMap, take, takeUntil, tap, } from 'rxjs/operators';
import { LogDetailsModalComponent } from './modals';
var LogEntityType;
(function (LogEntityType) {
    LogEntityType[LogEntityType["None"] = 0] = "None";
    LogEntityType[LogEntityType["Robot"] = 1] = "Robot";
    LogEntityType[LogEntityType["Job"] = 2] = "Job";
})(LogEntityType || (LogEntityType = {}));
var LogsFilterBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(LogsFilterBuilder, _super);
    function LogsFilterBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogsFilterBuilder.prototype.build = function (page, sort, searchFilters, originalFilters, expand, select, mapper) {
        var filters = cloneDeep(originalFilters);
        var userFilterIndex = filters.findIndex(function (f) { return f.property === 'user'; });
        if (userFilterIndex !== -1) {
            var userFilter = filters.splice(userFilterIndex, 1)[0];
            var queryOptions = _super.prototype.build.call(this, page, sort, searchFilters, filters, expand, select, mapper);
            queryOptions.filter.and.push({
                or: userFilter.value.map(function (RobotName) { return ({
                    RobotName: RobotName,
                }); }),
            });
            return queryOptions;
        }
        return _super.prototype.build.call(this, page, sort, searchFilters, filters, expand, select, mapper);
    };
    return LogsFilterBuilder;
}(ODataFilterBuilder));
export { LogsFilterBuilder };
var ɵ0 = urlStateHandler;
var LogsPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LogsPageComponent, _super);
    function LogsPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.logLevels = enumMapper(LogLevel, {
            resourceKey: 'LogLevel',
        });
        _this.defaultLogLevel = _this.logLevels
            .find(function (l) { return l.value === LogLevel.Trace.toString(); });
        _this.LogEntityType = LogEntityType;
        _this.isMachinesViewGranted$ = _this._appState.user.permissions.isGranted('Machines.View');
        _this.isProcessesViewGranted$ = _this._appState.user.permissions.isGranted('Processes.View');
        _this.isRobotsViewGranted$ = _this._appState.user.permissions.isGranted('Robots.View');
        _this._exportedCsvFileNameSubject = '';
        _this._route = _this._injector.get(ActivatedRoute);
        _this._logService = _this._service;
        _this._robotService = _this._injector.get(RobotService);
        _this._jobService = _this._injector.get(JobService);
        _this._modalService = _this._injector.get(ModalService);
        _this._downloadService = _this._injector.get(FileDownloadService);
        _this.machineNameSuggest = function (term, size, skip) {
            return _this._injector.get(MachineService).machineNameSuggest(term, size, skip);
        };
        _this.processNameSuggest = function (term, size, skip) {
            return _this._injector.get(ProcessService).suggestName(term, size, skip);
        };
        _this.usernameSuggest = function (term, size, skip) {
            return _this._injector.get(SessionsService).robotsByUsernameSuggest(term, size, skip);
        };
        _this._configureLogs = function (_a) {
            var entity = _a[0], params = _a[1];
            var entityType = params.get('entity');
            switch (entityType) {
                case 'robots':
                    entity = entity;
                    _this._filters$.next([{
                            value: entity.name,
                            method: 'eq',
                            property: 'robotName',
                        }]);
                    _this._exportedCsvFileNameSubject = _this._translate.instant('export_logs_robot') + "_" + entity.name;
                    break;
                case 'jobs':
                    entity = entity;
                    _this._filters$.next([{
                            value: entity.key,
                            type: 'guid',
                            method: 'eq',
                            property: 'jobKey',
                        }]);
                    _this._exportedCsvFileNameSubject = _this._translate.instant('export_logs_job') + "_" + entity.release.name;
                    break;
                default:
                    _this._exportedCsvFileNameSubject = "" + _this._translate.instant('export_logs_filename');
            }
        };
        return _this;
    }
    LogsPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._reportsUrl$ = this._activeQuery$.pipe(map(function (query) { return "" + _this._logService.reportsUrl + buildODataQuery(query) + "&" +
            ("fileNameSubject=" + _this._exportedCsvFileNameSubject); }));
        var entity$ = this._route.paramMap.pipe(tap(function () { return _this._state$.next(GridPageState.pending); }), switchMap(function (params) {
            var entity = params.get('entity');
            var id = params.get('id');
            switch (entity) {
                case 'robots':
                    _this.entityType = LogEntityType.Robot;
                    return _this._robotService.getInstance(Number(id));
                case 'jobs':
                    _this.entityType = LogEntityType.Job;
                    return _this._jobService.getInstance(Number(id), ['Release']);
                default:
                    _this.entityType = LogEntityType.None;
                    return of(null);
            }
        }));
        combineLatest([
            entity$,
            this._route.paramMap,
        ]).pipe(tap(this._configureLogs), tap(function () { return _this._state$.next(GridPageState.ready); }), takeUntil(this._destroyed$)).subscribe();
        this.realCount$ = this._activeQuery$.pipe(filter(function () { return _this._state$.value === GridPageState.ready; }), switchMap(function (qo) { return _this._logService.getRealCount(qo); }));
    };
    LogsPageComponent.prototype.showDetails = function (entry) {
        this._modalService.openModal(LogDetailsModalComponent, entry);
    };
    LogsPageComponent.prototype.downloadReport = function (event) {
        var _this = this;
        event.preventDefault();
        this._reportsUrl$.pipe(take(1)).subscribe(function (url) {
            _this._downloadService.download(url);
        });
    };
    LogsPageComponent.prototype._ouDependentFilters = function () {
        return ['processName'];
    };
    return LogsPageComponent;
}(ODataGridComponent));
export { LogsPageComponent };
export { ɵ0 };
